const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = [];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_system', 'tire_width', 'tire_aspect', 'tire_height', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields, 'Submodel'];

const categorySelectionPageUrl = '/categories/';
const brandSelectionPageUrl = '/brands/';

window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );
  const compareBtn = window.document.body.querySelector('.compareTool');
  const compareCount = window.document.body.querySelector('.compareTool .countPill');
  if (!compareBtn) {
    return;
  }

  compareCount.textContent = productsIdsToCompare.length;
  compareBtn.classList.toggle('show', productsIdsToCompare.length > 1);
  compareBtn.href = `/compare/${productsIdsToCompare.join('/')}/`;
};

window.Convermax.handleWishlistDropdown = (e) => {
  const wishlistDropdownForm = e.currentTarget.parentElement;
  const wishlistDropdown = e.currentTarget.parentElement.querySelector('.dropdown-menu');

  if (wishlistDropdownForm) {
    wishlistDropdownForm.classList.toggle('is-open');
  }

  if (wishlistDropdown) {
    wishlistDropdown.classList.toggle('is-open');

    // handle click on document, close opened dropdown
    if (wishlistDropdown.classList.contains('is-open')) {
      const handleClickOnDocument = (event) => {
        if (!wishlistDropdownForm.contains(event.target)) {
          wishlistDropdownForm.classList.remove('is-open');
          wishlistDropdown.classList.remove('is-open');
          document.removeEventListener('click', handleClickOnDocument);

          if (window.innerWidth <= 1000) {
            document.removeEventListener('touchmove', handleClickOnDocument);
          }
        }
      };

      document.addEventListener('click', handleClickOnDocument);

      if (window.innerWidth <= 1000) {
        document.addEventListener('touchmove', handleClickOnDocument);
      }
    }
  }
};

window.Convermax.discardVehicleAndTireSizes = () => {
  window.Convermax.discardVehicle();
  window.document
    .querySelector('.cm_FacetBarTires .cm_vehicle-widget_button__clear:not([disabled])')
    ?.click();
};

window.Convermax.toggleCollapsibleFitmentTable = (e) => {
  const header = e?.currentTarget;
  if (!header) {
    return;
  }

  const content = header.closest('.cm_fitment-table-container')?.querySelector('.cm_fitment-table-content');
  const icon = header.querySelector('.cm_fitment-table-header-icon');

  if (!content || !icon) {
    return;
  }

  content.classList.toggle('cm_hide');

  const isExpanded = !content.classList.contains('cm_hide');
  header.setAttribute('aria-expanded', String(isExpanded));
  icon.textContent = isExpanded ? '-' : '+';
};

export default {
  platform: 'bigcommerce',
  sortFields: ['relevance', '_popularity:desc', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
    extra: window.location.pathname === '/' ? { doNotHideWheelsTiresFacets: true } : {},
  },
  getSearchRequestDefaults: (pageType) => (pageType === 'category' ? { sort: '_popularity:desc' } : {}),
  product: { noImageSrc: '/img/ProductDefault.gif' },
  page: {
    getPageType: (defaults) =>
      window.location.pathname === categorySelectionPageUrl ||
      window.location.pathname === brandSelectionPageUrl
        ? 'parts'
        : defaults.getter(),
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
    ],
    onVehicleSelected: () => {
      const isMenuOpened = window.document
        .querySelector('.navPages-container')
        ?.classList.contains('is-open');
      const menuCloseElement = window.document.querySelector('#mobileCloseSarch');
      if (isMenuOpened && menuCloseElement) {
        menuCloseElement.click();
      }
    },
  },
  facets: {
    rangedFacet: [
      { fields: ['Load Rating (lbs.)'], step: '100' },
      { fields: ['Lift Height'], step: '1/10//1' },
      { fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } },
    ],
    toggleFacet: [{ fields: ['Fitment'], term: 'Vehicle-Specific' }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: { replace: '#main-content .page-content' },
      template: 'SearchPage',
      visibleIf: () => window.location.pathname === '/search/',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '.page',
      template: 'SearchPage',
      visibleIf: () =>
        window.document.body.classList.contains('page-type-category') ||
        window.document.body.classList.contains('page-type-brand'),
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    { name: 'SearchResult' },
    {
      name: 'SearchBox',
      location: '.desktop-search.main-search',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxSmallerDesktop',
      type: 'SearchBox',
      location: '.desktop-search.small-desktop-flex--search',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: '#quick-search-expand',
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: '.convermax-section--home #tab-vehicle',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 680,
    },
    {
      name: 'HomeWheelPanel_tab',
      type: 'RequestPanel',
      location: '.convermax-section--home #tab-wheels',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
    },
    {
      name: 'HomeTirePanel_tab',
      type: 'RequestPanel',
      location: '.convermax-section--home #tab-tires',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: tiresFields,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isVehicleSelectionIsolated: true,
    },
    {
      name: 'SingleVehicleGarage',
      location: {
        selector: '.select-vehicle-wrap .select-vehicle',
        class: 'cm_single-vehicle-garage cm_single-vehicle-garage__desktop',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'SingleVehicleGarageMobile',
      type: 'SingleVehicleGarage',
      location: {
        selector: '#menu .select-vehicle__mobile .navPages-action',
        class: 'cm_single-vehicle-garage cm_single-vehicle-garage__mobile',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'VerifyFitment',
      location: { lastChildOf: '.productView-details.product-options', class: 'productView-info' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: '#tab-fitment',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: '#fitmentTab',
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'CollapsibleFitmentTable',
      type: 'FitmentTable',
      location: {
        insertAfter: 'body.page-type-product .productView-option-a .productView-description',
        class: 'cm_fitment-table-collapsible',
      },
      template: 'fitmentSearch/collapsibleFitmentTable',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '.category-page-wrap',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname === categorySelectionPageUrl,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '.category-page-wrap',
      template: 'facetTiles/alphabeticalContainer',
      view: 'columns',
      visibleIf: () => window.location.pathname === brandSelectionPageUrl,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
